export const getImageInfo = (src: string) => {
  const img = new Image()
  img.src = src
  return img
}

export const getImageOrientation = (img: HTMLImageElement) => {
  let orientation = 'even'

  if (img.naturalWidth > img.naturalHeight) {
    orientation = 'landscape'
  } else if (img.naturalWidth < img.naturalHeight) {
    orientation = 'portrait'
  }

  return orientation
}
